import { render, staticRenderFns } from "./Shadow.vue?vue&type=template&id=0204a1d5&"
import script from "./Shadow.vue?vue&type=script&lang=ts&"
export * from "./Shadow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports